import { httpclient } from '@/api/sentinel/client';

export const getSentinelUrl = (path) => `${httpclient.defaults.baseURL}${path}`;

export const doLoginUser = ({ email, password }) => httpclient.post('/login', {
  email,
  password,
})
  .then((response) => response)
  .catch((error) => error.response);

export const doLogoutUser = () => httpclient.post('/logout')
  .then((response) => response)
  .catch((error) => error.response);

export const doSendPasswordForgetMail = ({ email }) => httpclient.post('/password-forget', { email })
  .then((response) => response)
  .catch((error) => error.response);

export const doSetPassword = ({ password }) => httpclient.post('/set-password', { password })
  .then((response) => response)
  .catch((error) => error.response);

export const doRegisterViaEmail = (payload) => httpclient.post('/register-mail', payload)
  .then((response) => response)
  .catch((error) => error.response);

export const doConfirmRegisterCode = (payload) => httpclient.post('/confirm-register-code', payload)
  .then((response) => response)
  .catch((error) => error.response);

export const doOAuthRegister = (payload) => httpclient.post('/oauth-register', payload)
  .then((response) => response)
  .catch((error) => error.response);

export const doOAuthLogin = (payload) => httpclient.post('/oauth-login', payload)
  .then((response) => response)
  .catch((error) => error.response);

export const doMSTeamsPasswordLogin = ({ email, password }) => httpclient.post('/msteams/password-login', {
  email,
  password,
})
  .then((response) => response)
  .catch((error) => error.response);

export const doMSTeamsLogin = ({ accessToken, provider, refreshToken, tokenExpiry, signedTrackedRequest, samlResponse }) => httpclient.post(
  '/msteams/login',
  {
    accessToken: decodeURIComponent(accessToken),
    provider: decodeURIComponent(provider),
    refreshToken: decodeURIComponent(refreshToken),
    tokenExpiry: decodeURIComponent(tokenExpiry),

    // saml
    signedTrackedRequest: decodeURIComponent(signedTrackedRequest),
    samlResponse: decodeURIComponent(samlResponse),
  },
);

export const fetchMe = () => httpclient.get('/me')
  .then((response) => response)
  .catch((error) => error.response);
